import {
  ErrorsInstrumentation,
  getWebInstrumentations,
  initializeFaro,
} from "@grafana/faro-web-sdk";
import { getEmailFromStorage } from "~/Auth/jwtUtils";
import { installGlobalErrorListener } from "~/error-handler/globalErrorListener";

// Installed before the app mounts, and regardless of whether Faro is configured,
// so that every uncaught error is classified (and the user notified) through
// one path.
installGlobalErrorListener();

const unsetEmail = "unset@example.com";
let email: string = unsetEmail;

const apiKey = window.config.grafanaFrontendApiKey;
if (process?.env?.NODE_ENV !== "development" && !!apiKey) {
  initializeFaro({
    url: `https://faro-collector-prod-us-central-0.grafana.net/collect/${apiKey}`,
    app: {
      name: "Wolfkrow-Frontend",
      version: window.config.version,
      environment: window?.config?.errorReporting?.service
        ?.split("-")
        .slice(-1)[0],
    },
    // Faro's own error capture is replaced by the global error listener: it
    // discards the original error object, so it cannot be classified, and it
    // would report every uncaught error a second time.
    instrumentations: getWebInstrumentations().filter(
      (instrumentation) => !(instrumentation instanceof ErrorsInstrumentation)
    ),
    // What gets reported is decided by error classification
    // (error-handler/classifyError), not here.
    beforeSend: (item) => {
      item.meta.user = {
        email,
      };
      return item;
    },
  });

  setInterval(() => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("oidc.user:")) {
        const newEmail = getEmailFromStorage(localStorage.getItem(key) ?? "");
        if (newEmail) {
          email = newEmail.toLowerCase();
          break;
        }
      }
    }
  }, 5000);
}
